module.exports = __webpack_public_path__ + "img/null.07b9f9bc.png";